import { useContext } from 'react'
import { ConfigParams } from '../types'
import { ConfigParamsContext } from '../context'

export const useConfigParams = (): ConfigParams => {
  return useContext(ConfigParamsContext)
}
